<template>
  <div class="main">
    <img src="@/assets/img/cooper/intelligence.png" />
    <div class="Con" v-if="playCoo">
      <div class="top">
        <div v-if="showTop">
          <img class="cover" src="@/assets/img/cooper/top_cover.png" alt="" />
          <div class="front">
            <div class="item AnimsRight" v-if="topShow[1]">城市建设</div>
            <div class="item AnimsRight" v-if="topShow[2]">经济发展</div>
            <div class="item AnimsRight" v-if="topShow[3]">城市治理</div>
          </div>
          <div class="baseTitle AnimsUp" v-if="topShow[0]">协同应用</div>
          <div class="behind AnimsUp" v-if="topShow[4]">
            <div class="smallItem i1">工程建设</div>
            <div class="smallItem i2">规划管控</div>
            <div class="smallItem">产业大数据</div>
            <div class="smallItem">数字产业园</div>
            <div class="smallItem i2">市域治理</div>
            <div class="smallItem i1">智慧交通</div>
          </div>
          <div class="totop AnimsUp" v-if="topShow[4]">
            <div class="smallItem">自然资源</div>
            <div class="smallItem">智慧城管</div>
          </div>
        </div>
      </div>
      <div class="center">
        <div v-if="showCenter">
          <img class="updown" src="@/assets/img/cooper/cent.png" alt="" />
          <img class="cover" src="@/assets/img/cooper/cent_cover.png" alt="" />
          <div class="front">
            <div v-if="centerShow[1]" class="item AnimsRight">数据汇聚</div>
            <div v-if="centerShow[2]" class="item AnimsRight">数据治理</div>
            <div v-if="centerShow[3]" class="item AnimsRight">服务集成</div>
          </div>
          <div class="baseTitle AnimsUp" v-if="centerShow[0]">赋能平台</div>
          <div class="behind AnimsUp" v-if="centerShow[4]">
            <div class="smallItem pTop">视频</div>
            <div class="smallItem tttop">IoT</div>
            <div class="smallItem eng">GIS</div>
            <div class="smallItem big">大数据</div>
            <div class="smallItem eng">CIM</div>
            <div class="smallItem tttop">AI</div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div v-if="showBottom">
          <img class="cover" src="@/assets/img/cooper/bottom_cover.png" alt="" />
          <div class="baseTitle AnimsUp" v-if="bottomShow[0]">数据资源</div>
          <div class="botTile">
            <div>
              <div class="botItem AnimsLeft leftTop" v-if="bottomShow[1]">信用数据</div>
              <div class="botItem AnimsLeft leftBottom" v-if="bottomShow[2]">人口数据</div>
            </div>
            <div>
              <div class="botItem toCen AnimsUp" v-if="bottomShow[3]">
                地理数据
              </div>
            </div>
            <div>
              <div class="botItem AnimsRight rightTop" v-if="bottomShow[4]">
                证照数据
              </div>
              <div class="botItem AnimsRight" v-if="bottomShow[5]">
                法人数据
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="endTitle">云计算+感知设备</div>
    </div>
  </div>
</template>
  
<script>
export default {
  name: "Cooperate",
  props: {
    playCoo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showTop: false,
      topShow: [false, false, false, false, false],
      showCenter: false,
      centerShow: [false, false, false, false, false],
      showBottom: false,
      bottomShow: [false, false, false, false, false, false],
    };
  },
  watch: {
    playCoo(val) {
      // console.log("playCoo",val);
      if (val) {
        this.initAnimate();
      }
    },
    immediate: true,
  },
  mounted() { },
  methods: {
    initAnimate() {
      this.showTop = false;
      this.topShow = [false, false, false, false, false];
      this.showCenter = false;
      this.centerShow = [false, false, false, false, false];
      this.showBottom = false;
      this.bottomShow = [false, false, false, false, false, false];
      setTimeout(() => {
        this.showCenter = true;
        this.centerShow.forEach((element, index) => {
          this.delyChangeCenter(index);
        });
      }, 3500);
      setTimeout(() => {
        this.showBottom = true;
        this.bottomShow.forEach((element, index) => {
          this.delyChangeBottom(index);
        });
      }, 500);
      setTimeout(() => {
        this.showTop = true;
        this.topShow.forEach((element, index) => {
          this.delyChangeTop(index);
        });
      }, 6000);
    },
    delyChangeTop(index) {
      setTimeout(() => {
        this.topShow[index] = true;
        this.$forceUpdate();
      }, 500 * index);
    },
    delyChangeCenter(index) {
      setTimeout(() => {
        this.centerShow[index] = true;
        this.$forceUpdate();
      }, 500 * index);
    },
    delyChangeBottom(index) {
      setTimeout(() => {
        this.bottomShow[index] = true;
        this.$forceUpdate();
      }, 500 * index);
    },
  },
};
</script>
  
<style lang="scss" scoped>
@import "../../assets/customAnimation.css";
.main {
  position: relative;
  width: 100vw;
  height: 100vh;
  .updown {
    // animation: updown 3s linear infinite;
    animation-name: appearCent1, updown;
    animation-duration: 2s, 3s;
    animation-iteration-count: 1, infinite;
  }
  .item {
    color: #fff;
  }
}
.AnimsRight {
  animation: fadeInRight; /* referring directly to the animation's @keyframe declaration */
  animation-duration: 1s; /* don't forget to set a duration! */
  // animation-delay: 4s;
}
.AnimsLeft {
  animation: fadeInLeft;
  animation-duration: 1s;
}
.AnimsUp {
  animation: fadeInUp;
  animation-duration: 1s;
}
.Con {
  position: absolute;
  top: 18%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #ffffff;
  .top {
    position: relative;
    height: 150px;
    img {
      position: absolute;
      top: -70px;
      z-index: -1;
      width: auto;
      // height: 540px;
      transform: translateX(-50%);
    }
    .baseTitle {
      margin: 20px 0;
    }
    .behind {
      .i1 {
        top: -30px;
      }
      .i2 {
        top: -10px;
      }
    }
    .totop {
      width: 700px;
      top: 60px;
      left: 100px;
      position: absolute;
      display: flex;
      justify-content: space-between;
      font-size: 18px;
    }
    .cover {
      animation-name: appearTop, display;
      animation-duration: 2s, 3s;
      // animation-delay: 0.3s, 0.6s;
      animation-iteration-count: 1, infinite;
    }
  }
  .center {
    position: relative;
    margin-top: 50px;
    height: 200px;
    img {
      position: absolute;
      top: -70px;
      z-index: -1;
      width: auto;
      height: 325px;
      transform: translateX(-50%);
    }
    .front {
      .item {
        background: url(../../assets/img/cooper/base_native.png) no-repeat
          center;
        background-size: cover;
      }
    }
    .updown {
      animation-name: appearCent1, updown;
      animation-duration: 2s, 3s;
      animation-iteration-count: 1, infinite;
    }
    .cover {
      animation-name: appearCentCover, display;
      animation-duration: 2s, 3s;
      animation-timing-function: ease-in-out, linear;
      animation-iteration-count: 1, infinite;
    }
    .baseTitle {
      margin: 30px 0;
    }
    .behind {
      font-weight: 900;
      position: relative;
      bottom: 10px;
      font-size: 20px;
      text-shadow: 5px 5px 10px #42b8ef;
      .pTop {
        top: -30px;
        margin-left: 120px;
      }
      .tttop {
        top: -5px;
        left: -35px;
      }
      .big {
        font-size: 25px;
        left: -40px;
      }
      .eng {
        left: -40px;
      }
    }
  }
  .bottom {
    margin: auto;
    margin-top: 100px;
    position: relative;
    img {
      position: absolute;
      top: -200px;
      z-index: -1;
      width: auto;
      // height: 290px;
      transform: translateX(-50%);
    }
    .botTile {
      position: absolute;
      left: 115px;
      top: -185px;
      display: flex;
      font-size: 20px;
      > div {
        width: 210px;
      }
      .leftTop {
        left: 50px;
      }
      .leftBottom {
        left: 35px;
      }
      .rightTop {
        right: 25px;
      }
      .botItem {
        margin: 135px 0;
        position: relative;
      }
      .toCen {
        position: relative;
        top: 190px;
        left: 10px;
      }
    }
    .cover {
      animation-name: appearBottom, display;
      animation-duration: 2s, 3s;
      // animation-delay: 1.5s, 1.3s;
      animation-iteration-count: 1, infinite;
    }
  }
  .front {
    width: 600px;
    height: 50px;
    margin-left: 180px;
    display: flex;
    justify-content: flex-start;
    .item {
      width: 160px;
      height: 50px;
      background: url(../../assets/img/cooper/base_active.png) no-repeat center;
      background-size: cover;
      line-height: 50px;
      font-size: 20px;
      font-weight: bold;
      margin: 0 10px;
    }
  }
  .behind {
    display: flex;
    font-size: 18px;
    width: 888px;
    .smallItem {
      margin: 0 35px;
      position: relative;
      top: 5px;
    }
  }
  .baseTitle {
    width: 888px;
    font-size: 30px;
    font-weight: bold;
    color: #4fc9e7;
  }
  .endTitle {
    font-size: 30px;
    position: relative;
    top: 150px;
    color: #9bd5e2;
  }
}
img {
  width: 1803px;
  margin-top: 100px;
}
</style>
<style lang="scss">
.el-carousel__indicators--horizontal {
  position: absolute;
  bottom: 5px;
  text-align: right;
  .el-carousel__indicator--horizontal button {
    width: 6px;
    height: 6px;
    background: #ffffff;
    border-radius: 50%;
    opacity: 0.5;
  }

  .el-carousel__indicator--horizontal.is-active button {
    width: 14px;
    height: 6px;
    background: #ffffff;
    opacity: 1;
    border-radius: 10px;
  }
}
</style>